const item = {
  release: {
    artist: {
      first: "",
      last: ""
    },
    label: {
      name: "",
      catalogNo: ""
    },
    titles: [
      ""
    ],
    tags: [],
    media: [
      {
        count: 1,
        attributes: [],
        size: null,
        duration: null,
        speed: null
      }
    ],
    genres: [
      {
        name: null
      }
    ],
    pressing: [],
    integrations: [
      {
        platform: "discogs"
      },
      {
        platform: "amazon"
      },
      {
        platform: "amazon-uk"
      }
    ],
    matchAttempts: []
  },
  listing: [
    {
      attributes: [],
      additions: [],
      type: "active",
      count: 0,
      condition: [
        {
          notes: [],
          grade: null,
          subject: "disc"
        }
      ],
      images: [],
      soundclips: []
    },
    {
      attributes: [],
      additions: [],
      type: "inactive",
      count: 0,
      condition: [],
      images: [],
      soundclips: []
    }
  ],
  suppressed: [],
  notes: [],
  salesHistory: [],
}

export default {
  data() {
      return {
          defaultInventoryItem: item
      }
  }
}